<template>
    <div class="home">
        <Notifications/>

        <CredentialsDialog v-if="selected_credentials" :id_account="selected_credentials.id_account" :loginname="selected_credentials.loginname" :password="selected_credentials.password" :status="selected_credentials.active" :site="selected_credentials.id_site" :company="selected_credentials.id_customer"/>
        <CredentialsDialog v-else :status="1"/>

        <div class="modal fade credentials-dialog" aria-hidden="true" id="cache-dialog">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h3 class="modal-title">Cache</h3>
                    </div>
                    <div class="modal-body">
                        <template v-if="cache">
                            Login and fail count are currently cached aggregations from {{ cache.valid_from|formatDate }} to {{ cache.valid_to|formatDate }}

                            <div>
                                The follow login id events were included:
                                <span v-if="!cache.id_events">All</span>
                                <span v-else v-for="e in cache.id_events" :key="'id-event-' + e">{{ e }}</span>
                            </div>
                        </template>
                        <span v-else>No cache</span>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                    </div>
                </div>
            </div>
        </div>

        <div class="container-fluid">
            <Navbar/>

            <div class="row content">
                <div class="col-md-2 sidebar-container">
                    <Sidebar/>
                </div>

                <div class="col-md-10 ml-md-auto">
                    <div class="container-inner">
                        <div class="container-header">
                            <div class="row">
                                <div class="col">
                                    <h2 v-if="!id_list">Results</h2>
                                    <h2 v-else>ID List: {{ id_list }}</h2>
                                    <h4 class="subtitle" v-if="pagination.totalItems > 0">Total credentials: {{ pagination.totalItems }}</h4>
                                </div>
                                <div class="col credentials-col">
                                    <button type="button" class="btn" data-toggle="modal" data-target="#cache-dialog">Show cache</button>
                                    <button @click="show_detailed = !show_detailed" type="button" class="btn" :class="{ 'btn-outline-secondary': show_detailed, 'btn-secondary': !show_detailed }" title="Hides/shows login name and password">
                                        <template v-if="show_detailed">Hide detailed</template>
                                        <template v-else>Show detailed</template>
                                    </button>
                                    <button @click="selected_credentials = null" type="button" class="btn btn-success" data-toggle="modal" data-target="#credentials-dialog">Add credentials</button>
                                </div>
                            </div>
                        </div>
                        <div class="container-content">


                            <div v-if="loading" class="spinner-container"><div class="spinner-border" role="status"></div></div>
                            <template v-else-if="logins && logins.length">
                                <Pagination v-bind:pagination="pagination"/>

                                <table class="table table-striped table-bordered table-hover table-md-responsive table-compact">
                                    <thead class="thead-dark">
                                        <tr>
                                            <th class="split sortable" v-bind:class="{active: sort === 'id_site', sortDesc: sortDir === 'desc'}" @click="sortBy('id_site')">Site</th>
                                            <th class="split sortable" v-bind:class="{active: sort === 'id_account', sortDesc: sortDir === 'desc'}" @click="sortBy('id_account')">id_account</th>
                                            <th class="split sortable" v-bind:class="{active: sort === 'loginname', sortDesc: sortDir === 'desc'}" @click="sortBy('loginname')" v-show="show_detailed">Login name</th>
                                            <th class="split sortable" v-bind:class="{active: sort === 'password', sortDesc: sortDir === 'desc'}" @click="sortBy('password')" v-show="show_detailed">Password</th>
                                            <th class="split sortable" v-bind:class="{active: sort === 'start_date', sortDesc: sortDir === 'desc'}" @click="sortBy('start_date')">Created</th>
                                            <th class="split sortable" v-bind:class="{active: sort === 'end_date', sortDesc: sortDir === 'desc'}" @click="sortBy('end_date')">End date</th>
                                            <th class="split sortable" v-bind:class="{active: sort === 'id_customer', sortDesc: sortDir === 'desc'}" @click="sortBy('id_customer')">Company</th>
                                            <th class="split sortable" v-bind:class="{active: sort === 'active', sortDesc: sortDir === 'desc'}" @click="sortBy('active')">Status</th>
                                            <th class="split sortable" v-bind:class="{active: sort === 'login_success', sortDesc: sortDir === 'desc'}" @click="sortBy('login_success')">Success count</th>
                                            <th class="split sortable" v-bind:class="{active: sort === 'login_fail', sortDesc: sortDir === 'desc'}" @click="sortBy('login_fail')">Fail count</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="e in logins" :key="e.id" :class="{ 'site-disabled': e.active_sections === 0 }">
                                            <td class="split">
                                                <router-link class="link" :to="{ name: 'site', params: { id_site: e.id_site }}">
                                                    {{ e.sitename }}
                                                    <sup>{{ e.id_site }}</sup>
                                                </router-link>
                                            </td>
                                            <td class="split">
                                                <span class="link" data-toggle="modal" data-target="#credentials-dialog" @click="selected_credentials = e">{{ e.id_account }}</span>
                                            </td>
                                            <td v-show="show_detailed">
                                                <span>{{ e.loginname }}</span>
                                            </td>
                                            <td v-show="show_detailed">
                                                <span>{{ e.password }}</span>
                                            </td>
                                            <td>
                                                <span>{{ e.start_date|formatDate }}</span>
                                            </td>
                                            <td>
                                                <span>{{ e.end_start|formatDate }}</span>
                                            </td>
                                            <td class="split">
                                                <router-link class="link" :to="{ name: 'company', params: { id_customer: e.id_customer }}">
                                                    {{ e.company_name }}
                                                    <sup>{{ e.id_customer }}</sup>
                                                </router-link>
                                            </td>
                                            <td class="split">
                                                <span>{{ e.active|formatStatus }}</span>
                                            </td>
                                            <td class="split">
                                                <span>{{ e.login_success }}</span>
                                            </td>
                                            <td class="split">
                                                <span>{{ e.login_fail }}</span>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>

                                <Pagination v-bind:pagination="pagination"/>
                            </template>
                            <div v-else>
                                <span v-if="error">Error fetching from API</span>
                                <span v-else class="no-results">No results</span>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Notifications from '@/components/Notifications.vue'
import Sidebar from '@/components/Sidebar.vue'
import Pagination from '@/components/Pagination.vue'
import Navbar from '@/components/Navbar.vue'
import CredentialsDialog from '@/components/CredentialsDialog.vue'

export default {
    name: 'Home',
    data() {
        return {
            selected_credentials: null,
            show_detailed: true
        }
    },
    methods: {
        sortBy(column) {
            // DESC -> ASC -> Null
            if (this.sort && this.sort == column) {
                if (this.sortDir == 'desc') {
                    this.sort = column
                    this.sortDir = 'asc'
                } else {
                    this.sort = null
                    this.sortDir = 'desc'
                }
            } else {
                this.sort = column
                this.sortDir = 'desc'
            }
        }
    },
    components: {
        Notifications, Sidebar, Pagination, Navbar, CredentialsDialog
    },
    created: function() {
        this.$store.dispatch('fetchLogins')
    },
    computed: {
        auth: function() {
            return this.$store.state.auth
        },
        cache: function() {
            return this.$store.state.cache
        },
        logins: function() {
            return this.$store.state.logins
        },
        pagination: function() {
            return this.$store.state.pagination
        },
        loading: function() {
            return this.$store.state.loading
        },
        error: function() {
            return this.$store.state.error
        },
        submittingUpdate: function() {
            return this.$store.state.submittingUpdate
        },
        search: {
            get() {
                return this.$store.state.selected
            },
            set(value) {
                this.$store.commit('toggleStatus', value)
            }
        },
        info: {
            get() {
                return this.$store.state.info
            },
            set(value) {
                this.$store.commit('updateInfo', value)
            }
        },
        id: {
            get() {
                return this.$store.state.id
            },
            set(value) {
                this.$store.commit('updateId', value)
            }
        },
        id_link: {
            get() {
                return this.$store.state.filters.id_link
            },
            set(value) {
                this.$store.commit('updateIdLink', value)
            }
        },
        company: {
            get() {
                return this.$store.state.filters.company
            },
            set(value) {
                this.$store.commit('updateCompany', value)
            }
        },
        selectedAll: {
            get() {
                return this.$store.state.selectedAll
            },
            set(value) {
                this.$store.commit('updateSelectedAll', value)
            }
        },
        selected: {
            get() {
                return this.$store.state.selected
            },
            set(value) {
                this.$store.commit('updateSelected', value)
            }
        },
        sort: {
            get() {
                return this.$store.state.sort
            },
            set(value) {
                this.$store.commit('updateSort', value)
            }
        },
        sortDir: {
            get() {
                return this.$store.state.sortDir
            },
            set(value) {
                this.$store.commit('updateSortDir', value)
            }
        }
    },
    watch: {
        'pagination.page': function() {
            this.selectedAll = false
            this.$store.dispatch('fetchLogins')
        },
        showDialog: function(n) {
            if (!n) {
                this.info = null
            }
        },
        submittingUpdate: function(n, o) {
            if (!o && n) {
                this.closeDialog();
            }
        },
        sort: function() { this.$store.dispatch('fetchLogins') },
        sortDir: function() { this.$store.dispatch('fetchLogins') }
    },
}
</script>

<style scoped lang="sass">
@import '@/styles/_variables.sass'

.home
    height: 100%
    position: relative

    .table-compact
        font-size: 0.9rem

    th, td
        padding: 0.5rem

    tr.site-disabled
        background-color: rgba(0,0,0,.05)
        opacity: 0.9
        &, a, span
            color: #ccc

    .status-th
        min-width: 100px

    .subtitle
        color: $gray
        font-size: $font-size
        font-weight: 400
        margin: 8px 0 0

    .link
        color: $gray
        cursor: pointer
        text-decoration: none

        &:hover
            color: $black

    .small-text
        font-size: $font-size-small

    .container
        margin-left: $sidebar-width
        height: 100%
        position: relative
        display: flex
        flex-direction: column

        .container-header
            padding: 30px
            text-align: left

            h1
                margin: 0
                font-size: $font-size-bigger

        .container-content
            padding: 10px 20px

        .container-inner
            flex-grow: 1
            overflow: auto
</style>
